/** sessionStorage key with the address fields passed from the product page (IPOST, UKLON) to the checkout */
export const EXPRESS_DELIVERY_FIELDS_KEY = 'expressDeliveryFields';
